// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"671":"248b1b82","912":"996c2d41"}[chunkId] + ".js";
};